export default __webpack_public_path__ + "static/sylfirmx-benefits-35e6d61190fdfde750dfbdae7f41af38.jpg";